import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import moment from 'moment';
import { Moment } from 'moment';
import { Case, CaseDocument, CaseType } from 'src/app/models/case';
import { Document } from 'src/app/models/document';
import { Paginator } from 'src/app/models/paginator';
import { ProductService } from 'src/app/models/productService';
import { Territory } from 'src/app/models/territory';
import { DocumentService } from 'src/app/services/document.service';
import { TerritoryService } from 'src/app/services/territory.service';

@Component({
  selector: 'app-documents-case',
  templateUrl: './documents-case.component.html',
  styleUrls: ['./documents-case.component.scss']
})
export class DocumentsCaseComponent implements OnChanges, OnInit {
  CaseType = CaseType;
  @Input() case?: Case;
  @Input() productsServices?: ProductService[];
  @Input() trademarkProductsServices?: ProductService[];
  @Input() from?: string;
  @Input() documents: Paginator<CaseDocument> = {
    docs: [],
    page: 1,
    offset: 0,
    limit: 10,
    totalDocs: 0,
    sort: '-createdAt'
  };
  @Input() filteredDocuments: CaseDocument[] = [];
  @Input() readonly: boolean = false;
  displayedColumns: string[] = ['select', 'name', 'nice', 'period', 'score'];
  dataSource: MatTableDataSource<CaseDocument> = new MatTableDataSource<CaseDocument>([])
  @Input() selection = new SelectionModel<CaseDocument>(true, []);
  @Output() selectionChange = new EventEmitter<SelectionModel<CaseDocument>>();

  @Output() sort = new EventEmitter<any>();
  @Output() page = new EventEmitter<PageEvent>();
  @Output() select = new EventEmitter<any>();
  territories: Territory[] = [];

  constructor(
    public documentService: DocumentService,
    private territoryService: TerritoryService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService
  ) {

  }

  async ngOnInit() {
    if (this.case?.type !== CaseType.RENEWAL_MAINTENANCE)
      this.displayedColumns = ['select', 'name', 'nice', 'territories', 'period', 'score'];
    try {
      this.territories = await this.territoryService.retrieve();
    } catch (err) {
      // The territories column falls back to the raw trademark designations
      console.error('Failed to load territories', err);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataSource = new MatTableDataSource<CaseDocument>(this.filteredDocuments);
  }

  documentIcon(document: CaseDocument) {
    return this.documentService.icon(document);
  }

  formatSize(document: CaseDocument) {
    return this.documentService.size(document);
  }

  formatPeriod(document: CaseDocument) {
    return this.documentService.period(document);
  }

  formatDate(date: Moment) {
    return moment(date).format('ll');
  }

  flushSelection() {
    this.selection = new SelectionModel<CaseDocument>(true, []);
    this.selectionChange.emit(this.selection);
  }

  hasPageSelection() {
    return this.dataSource.data.some(row => this.isSelected(row))
  }

  isSelected(row: CaseDocument) {
    return this.selection.selected.map(doc => doc._id).includes(row._id)
  }

  isAllSelected() {
    return this.dataSource.data.every(row => this.isSelected(row));
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      const difference = _.differenceBy(this.selection.selected, this.dataSource.data, '_id')
      this.selection.setSelection(...difference)
      this.selectionChange.emit(this.selection);
      return;
    }
    this.selection.setSelection(...[...this.selection.selected, ...this.dataSource.data.filter(row => !this.isSelected(row))])
    this.selectionChange.emit(this.selection);
  }

  toggle(row: CaseDocument) {
    if (this.isSelected(row)) {
      this.selection.setSelection(...this.selection.selected.filter(doc => doc._id !== row._id))
    } else {
      this.selection.setSelection(...[...this.selection.selected, row])
    }
    this.selectionChange.emit(this.selection);
  }

  onSortChange(event: any) {
    if (event.active === 'period') {
      if (event.direction === 'asc') {
        event.active = 'period.start'
      } else {
        event.active = 'period.end'
      }
    }
    this.sort.emit(event)
  }

  async handlePage(event: PageEvent) {
    this.page.emit(event);
  }

  getProductsServices() {
    if (this.hasProductsServices()) {
      const productsServices: ProductService[] = [];
      if (this.case && this.case.productsServices) {
        this.case.productsServices.forEach((cps) => {
          const found = this.trademarkProductsServices?.find((tps) => tps._id === cps.ref);
          if (found) {
            productsServices.push(found)
          }
        })
      }
      return productsServices;
    } else if (this.trademarkProductsServices) {
      return this.trademarkProductsServices
    } else {
      return [];
    }
  }

  hasProductsServices() {
    return (this.case && this.case.productsServices) ? this.case.productsServices.length > 0 : false;
  }

  _setDocumentFiltersBasedOnCase() {
    if (this.case) {
      this.documentService.filters = {
        query: undefined,
        approval: [],
        classNumber: this.case?.niceClassification,
        productsServices: this.getProductsServices(),
        territories: [this.case.trademark.countryOfDesignation],
        documentClass: [],
        // _id is required for the document page metadata filters to match the
        // case trademark against the stored metadata value (ref first).
        trademark: [{ ...this.case.trademark, _id: this.case.trademark.ref }],
        trademarkFamily: [],
        period: {
          start: moment(this.case.timePeriod.start),
          end: moment(this.case.timePeriod.end)
        },
        tags: []
      }
    }
  }

  toDocument(document: CaseDocument) {

    this._setDocumentFiltersBasedOnCase();

    this.router.navigateByUrl(`/documents/${document._id}`, {
      state: {
        from: "CASE",
        fromId: this.case?._id
      }
    })
  }

  downloadDocument(document: CaseDocument) {
    // this.otpService.check(() => console.log("ok"), () => console.log("ko"))
  }

  documentCases(document: CaseDocument) {

  }

  linkDocument(document: CaseDocument) {

  }

  deleteDocument(document: CaseDocument) {

  }
}
